import { render, staticRenderFns } from "./PayPalPaymentStatus.vue?vue&type=template&id=406ec6a2&scoped=true&"
import script from "./PayPalPaymentStatus.vue?vue&type=script&lang=ts&"
export * from "./PayPalPaymentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./PayPalPaymentStatus.vue?vue&type=style&index=0&id=406ec6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ec6a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VFlex,VLayout,VProgressCircular})
